<lex-action-panel>
    <div action-title>Notes</div>
    <div action-body class="fontify-13px">
        <div style="display: flex; flex-direction: column; padding:20px; gap: 16px;" >
            <ng-container *ngIf="latestDocNote && latestDocNote.author">
                <div style="display: flex; flex-direction:row; margin-left: 6px;">
                    <i class="fa-duotone fa-badge-check"
                        style="--fa-primary-color: white;
                                  --fa-secondary-color: green; --fa-secondary-opacity: 1; margin-right: 8px; font-size: 14px;"></i>
                    <div>Last updated by {{latestDocNote.author}}</div>
                </div>
            </ng-container>
            <lex-text-input class="note-body-input" [type]="'textarea'" placeholder="Please add a note."
                [formControl]="noteControl" rows=10></lex-text-input>
            <mat-error *ngIf="noteControl.invalid && noteControl.touched">
                <ng-container *ngIf="noteControl.errors.maxlength">
                    Note must be at most 8000 characters long.
                </ng-container>
                <ng-container *ngIf="noteControl.errors.pattern">
                    Note must not contain < or >.
                </ng-container>
            </mat-error>
        </div>
    </div>
</lex-action-panel>
